module.exports = __webpack_public_path__ + "static/009-0247ed0f1849182eaec5e259d1c28846.png";